var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanknote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 36,
    viewBox: "0 0 56 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 18H12.0263M43.9997 18H44.0263M6.66634 2H49.333C52.2785 2 54.6663 4.38781 54.6663 7.33333V28.6667C54.6663 31.6122 52.2785 34 49.333 34H6.66634C3.72082 34 1.33301 31.6122 1.33301 28.6667V7.33333C1.33301 4.38781 3.72082 2 6.66634 2ZM33.333 18C33.333 20.9455 30.9452 23.3333 27.9997 23.3333C25.0542 23.3333 22.6663 20.9455 22.6663 18C22.6663 15.0545 25.0542 12.6667 27.9997 12.6667C30.9452 12.6667 33.333 15.0545 33.333 18Z",
    stroke: "#6D33FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 18H12.0263M43.9997 18H44.0263M6.66634 2H49.333C52.2785 2 54.6663 4.38781 54.6663 7.33333V28.6667C54.6663 31.6122 52.2785 34 49.333 34H6.66634C3.72082 34 1.33301 31.6122 1.33301 28.6667V7.33333C1.33301 4.38781 3.72082 2 6.66634 2ZM33.333 18C33.333 20.9455 30.9452 23.3333 27.9997 23.3333C25.0542 23.3333 22.6663 20.9455 22.6663 18C22.6663 15.0545 25.0542 12.6667 27.9997 12.6667C30.9452 12.6667 33.333 15.0545 33.333 18Z",
    stroke: "url(#paint0_linear_49096_5213)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49096_5213",
    x1: -2.20205,
    y1: 8.51304,
    x2: 40.1377,
    y2: 46.1986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknote);
export default __webpack_public_path__ + "static/media/banknote.939879c67e6464bbd2a3361473c13ed6.svg";
export { ForwardRef as ReactComponent };